var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('pdf',{ref:"pdf",attrs:{"src":_vm.pdfUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }